// Import the functions you need from the SDKs you need

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyCNA98XoiieY83i9gp3Dsnn1Rtw-p4VHaI",
  authDomain: "matias-aguilar.firebaseapp.com",
  projectId: "matias-aguilar",
  storageBucket: "matias-aguilar.appspot.com",
  messagingSenderId: "493911504762",
  appId: "1:493911504762:web:52b0b6203f0142eac188c3",
  measurementId: "G-5628N60681"
};

// Initialize Firebase

// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

// Initialize Firebase

firebase.initializeApp(firebaseConfig);
firebase.auth=firebase.auth()
firebase.db=firebase.firestore()
export default firebase;